/**
 * Fixture data for the AppShell component gallery (/shell-demo). Not wired
 * to any store — Phase 1 builds these components in isolation, per
 * assets/handoffs/design_handoff_app_shell.
 */

export const account = {
  name: "Maria Kotopoulou",
  email: "maria@revisual.io",
  initials: "MK",
};

export const workspaces = [
  { uuid: "ws-1", name: "Dev account", initials: "DA", current: true },
  { uuid: "ws-2", name: "Client — Northwind Traders", initials: "NT" },
  { uuid: "ws-3", name: "Client — Acme Events", initials: "AE" },
];

export const currentWorkspace = workspaces.find((w) => w.current);

export const navSections = {
  top: [{ key: "dashboard", label: "Dashboard", icon: "HomeLine", to: "/dashboard" }],
  widgets: {
    key: "widgets_menu",
    label: "Widgets",
    icon: "Grid01",
    children: [
      { key: "calendar", label: "Calendars", to: "/calendars" },
      { key: "groups", label: "Groups", to: "/groups" },
      // { key: "alerts", label: "Event alerts", to: "/alerts" },
      // { key: "signup", label: "Sign-up forms", to: "/signups" },
    ],
  },
  reports: {
    key: "reports_menu",
    label: "Reports",
    icon: "BarChart08",
    children: [
      { key: "eventEngagement", label: "Event engagement", to: "/reports/event-engagement" },
      { key: "planUsage", label: "Plan usage", to: "/reports/plan-usage" },
    ],
  },
  standalone: [
    { key: "integrations", label: "Integrations", icon: "Dataflow04", to: "/integrations" },
    { key: "domains", label: "Websites", icon: "Browser", to: "/domains" },
  ],
  platformSettings: {
    key: "platform_settings_menu",
    label: "Platform settings",
    icon: "Settings01",
    children: [
      { key: "organizations", label: "Organizations", to: "/organizations" },
      { key: "users", label: "Users", to: "/users" },
      { key: "accounts", label: "Accounts", to: "/accounts/2026" },
      { key: "queueWorkers", label: "Queues", to: "/queue-workers" },
    ],
  },
};

export const alerts = [
  {
    id: "quota",
    variant: "warning",
    icon: "AlertTriangle",
    title: "Widgets paused",
    body: "Quota resets 1 July.",
    action: { label: "Manage plan", to: "/dashboard" },
  },
  {
    id: "affiliate",
    variant: "promo",
    icon: "Gift01",
    body: "Earn 20% recurring commission as an affiliate.",
    action: { label: "Learn more", to: "/dashboard" },
  },
];

export const impersonation = {
  active: true,
  accountName: "Northwind Traders",
};

export const workspaceSettingsTabs = [
  { key: "general", label: "General", to: "/organization-settings" },
  { key: "branding", label: "Branding", to: "/organization-settings/branding" },
  { key: "members", label: "Members", to: "/organization-settings/members", badge: "Beta" },
  { key: "billing", label: "Billing", to: "/organization-settings/billing" },
  { key: "domain", label: "Domain & links", to: "/organization-settings/domain", badge: "Beta" },
];

export const accountSettingsTabs = [
  { key: "profile", label: "Profile", to: "/settings" },
  // { key: "affiliates", label: "Affiliates", to: "/settings/affiliates" },
];
